import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fatura',
  templateUrl: './fatura.component.html',
  styleUrls: ['./fatura.component.scss'],
})
export class FaturaComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  gosterilenIsleme: number = 0;
  constructor() {}

  ngOnInit(): void {}
  tempId: number;
  GetCompanyCities(id: number) {
    this.tempId = JSON.parse(JSON.stringify(id));
    if (this.gosterilenIsleme != id) {
      this.gosterilenIsleme = id;
    } else {
      this.gosterilenIsleme = -1;
    }
  }

  gosterilenIsletmeGosterGizle() {
    this.gosterilenIsleme = null;
  }
}
